/**
 * One labelled read-only field in a pricing header grid.
 *
 * Shared by the SPA record detail route and the SPA request detail content,
 * which each had a byte-identical private copy.
 */
export function HeaderField({
  label,
  value,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span className="text-sm">{value}</span>
    </div>
  );
}
